import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk-legacy/ui-react-utils';

import { HorizontalDashes } from '../../../../../../../src/components/common/dashes';
import Text from '../../../../../../../src/components/common/text';
import { SEPARATOR_STROKE } from '../../../../../../../src/constants';
import styles from './transaction-details.styles';

function TransactionDetailsDescription(props) {
  const { description } = props;

  if (description && description.length > 14) {
    return (<View>
      <Text type="secondary">{description}</Text>

      <View style={styles.separator}>
        <HorizontalDashes stroke={SEPARATOR_STROKE} />
      </View>
    </View>);
  }

  return null;
}

TransactionDetailsDescription.propTypes = {
  description: PropTypes.string,
};

export default pure(TransactionDetailsDescription);
